import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import AppLoading from './AppLoading';
import AccountLoadError from './Auth/AccountLoadError';

const ProtectedRoute = ({ children }) => {
  const { currentUser, emailVerified, accountProfile, accountLoading, accountError } = useAuth();
  const location = useLocation();
  const { loadLanguagePreference } = useLanguage();
  const companyId = accountProfile?.companyId;
  useEffect(() => {
    if (companyId) loadLanguagePreference(companyId);
  }, [companyId, loadLanguagePreference]);
  if (!currentUser) return <Navigate to="/login" replace state={{ from: location }} />;
  if (!emailVerified) return <Navigate to="/verify-email" replace state={{ from: location }} />;
  if (accountLoading) return <AppLoading />;
  if (accountError) return <AccountLoadError />;
  if (!accountProfile?.complete) return <Navigate to="/onboarding" replace state={{ from: location }} />;
  return children;
};

export default ProtectedRoute;
